import React from 'react';
import NewNav from "./NewNav";
import NewingArea from "./NewingArea";

export default function New(props) {

    const newBaseStyles = "New  rounded-tl-mega bg-purple-slumber rounded-br-mega text-white lg:grid lg:grid-rows-12 lg:grid-cols-12"
    const newMobStyles = " hidden "
    const newLargeStyles = " lg:block lg:col-start-1 lg:col-end-8 lg:row-start-1 lg:row-end-13 "
    const newExtraLargeStyles = " 3xl:col-end-7 "

    return (
        <div className={` ${newBaseStyles} ${newMobStyles} ${newLargeStyles} ${newExtraLargeStyles} `}>

            <NewNav />
            <NewingArea />

        </div>
    );
}

